export default __webpack_public_path__ + "images/5428d922d31595080ac7ed762c4d9c04-ChatRectangle.png";